/* ============================================================
   Sticky add-to-cart (C2 / S3 + A4 + B5)
   Drives the theme's [data-variant-input] radios, not the no-js <select>.
   ============================================================ */
(function () {
  'use strict';

  var COMPARE_SECTION = '.whats-included-area';
  var COMPARE_PANE    = '.tab-pane';
  var MIN_PANES       = 2;

  var TEASER_SEL = '[data-testid="teaser-container"],[data-testid="TEASER"],[class*="kl-teaser"]';

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.satcInit === '1') return;

    var realBtn   = document.querySelector('[data-add-to-cart]');
    var realSel   = document.querySelector('[data-product-select]');
    var realPrice = document.querySelector('[data-product-price]');
    if (!realBtn) return;

    bar.dataset.satcInit = '1';

    var barSel   = bar.querySelector('[data-sticky-select]');
    var barPrice = bar.querySelector('[data-sticky-price]');
    var barBtn   = bar.querySelector('[data-sticky-add]');
    var barText  = bar.querySelector('[data-sticky-add-text]');
    var realText = realBtn.querySelector('[data-add-to-cart-text]');

    /* ---------- park the Klaviyo 15% teaser clear of this bar ----------
       The bar's height is not constant: 2 rows on a single-variant kit,
       3 once there is a version picker, taller again with the iOS safe area.
       On a short phone the teaser's default CSS position sits inside where
       the bar will be, so it has to be moved out of the way.

       This is done with an inline style rather than a body class + CSS rule
       on purpose. A class is applied by the IntersectionObserver, which does
       not fire until the scroll settles — on a fast flick the teaser rendered
       on top of the bar and then hopped upwards a moment later. The bar's
       height is known from the moment the page lays out, so the teaser is
       parked above it permanently, visible bar or not. Nothing moves on
       scroll, so there is nothing to be late for.

       Inline !important also cannot lose a cascade fight with Klaviyo's own
       injected styles, which is why the CSS-only attempt never took effect. */
    /* V152: the bar's height comes from a ResizeObserver, not offsetHeight —
       reading offsetHeight here forced a full layout on every DOM change on
       the page (~390 ms of main thread on a phone). */
    var barH = 0;
    if (window.ResizeObserver) {
      new ResizeObserver(function () { barH = bar.offsetHeight; placeTeaser(); }).observe(bar);
    }
    function placeTeaser() {
      var h = barH || bar.offsetHeight;      // unaffected by the bar's translate
      if (!h) return;
      var px = (h + 16) + 'px';
      var els = document.querySelectorAll(TEASER_SEL);
      for (var i = 0; i < els.length; i++) {
        if (els[i].style.bottom !== px) els[i].style.setProperty('bottom', px, 'important');
      }
    }

    /* Klaviyo injects the teaser asynchronously, well after DOMContentLoaded,
       and re-renders it on its own schedule. Watch for it, cheaply. */
    if (window.MutationObserver) {
      var queued = false;
      /* V152: only wake for Klaviyo's nodes, not for every change on the page */
      var KL = '[class*="kl-"],[class*="klaviyo"],' + TEASER_SEL;
      var mine = function (n) {
        return n && n.nodeType === 1 && ((n.matches && n.matches(KL)) || (n.closest && n.closest(KL)) || (n.querySelector && n.querySelector(TEASER_SEL)));
      };
      new MutationObserver(function (recs) {
        if (queued) return;
        var hit = false;
        for (var r = 0; r < recs.length && !hit; r++) {
          if (mine(recs[r].target) && recs[r].target !== document.body) { hit = true; break; }
          var a = recs[r].addedNodes;
          for (var j = 0; j < a.length; j++) { if (mine(a[j])) { hit = true; break; } }
        }
        if (!hit) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; placeTeaser(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    [0, 300, 1200, 3000].forEach(function (d) { setTimeout(placeTeaser, d); });

    /* ---------- publish the bar's real height ----------
       Kept for any other fixed UI that wants to clear the bar. */
    function measure() {
      document.documentElement.style.setProperty('--gob-satc-h', bar.offsetHeight + 'px');
      placeTeaser();
    }

    /* ---------- price mirror (variant change AND the GOB Club toggle) ---------- */
    function syncPrice() {
      if (realPrice && barPrice) barPrice.innerHTML = realPrice.innerHTML;
    }
    if (realPrice && window.MutationObserver) {
      new MutationObserver(function () { syncPrice(); measure(); }).observe(realPrice, {
        childList: true, subtree: true, characterData: true
      });
    }

    /* ---------- button label + disabled mirror ---------- */
    function syncBtn() {
      if (realText && barText) barText.textContent = realText.textContent.trim();
      if (barBtn) barBtn.disabled = !!realBtn.disabled;
    }
    if (window.MutationObserver) {
      new MutationObserver(syncBtn).observe(realBtn, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'class']
      });
    }

    /* ---------- bar select -> theme radios ---------- */
    function applyVariant() {
      if (!barSel) return;
      var opt = barSel.options[barSel.selectedIndex];
      if (!opt) return;

      ['option1', 'option2', 'option3'].forEach(function (idx, i) {
        var want = opt.getAttribute('data-o' + (i + 1));
        if (!want) return;

        var radios = document.querySelectorAll('[data-variant-input][data-index="' + idx + '"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === want) {
            if (!radios[j].checked) {
              radios[j].click();
              radios[j].dispatchEvent(new Event('change', { bubbles: true }));
            }
            break;
          }
        }
      });

      if (realSel && realSel.value !== barSel.value) realSel.value = barSel.value;

      setTimeout(function () { syncPrice(); syncBtn(); measure(); }, 120);
      setTimeout(function () { syncPrice(); syncBtn(); measure(); }, 400);
    }

    if (barSel) barSel.addEventListener('change', applyVariant);

    /* ---------- theme radios -> bar select ---------- */
    document.addEventListener('change', function (e) {
      if (!barSel || !e.target || !e.target.hasAttribute) return;
      if (!e.target.hasAttribute('data-variant-input')) return;

      setTimeout(function () {
        if (realSel && realSel.value && barSel.value !== realSel.value) {
          barSel.value = realSel.value;
        }
        syncPrice(); syncBtn(); measure();
      }, 120);
    }, true);

    /* ---------- forward the click to the real button ---------- */
    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn.click();
      });
    }

    var cmpBtn = bar.querySelector('[data-sticky-compare]');
    if (cmpBtn) {
      var section = document.querySelector(COMPARE_SECTION);
      var panes = section ? section.querySelectorAll(COMPARE_PANE) : [];
      var hasComparison = !!(section && panes.length >= MIN_PANES);
      var storySection = document.querySelector('#gob-story-included');

      function storyTarget() {
        return storySection && storySection.isConnected && storySection.getClientRects().length ? storySection : null;
      }

      function updateCompareVisibility() {
        var available = !!storyTarget() || hasComparison;
        cmpBtn.hidden = !available;
        if (bar.classList.contains('gob-satc--single')) {
          cmpBtn.parentNode.hidden = !available;
          bar.classList.toggle('has-included-link', available);
        }
      }

      if (hasComparison || storySection) {
        updateCompareVisibility();
        window.addEventListener('resize', updateCompareVisibility, { passive: true });

        cmpBtn.addEventListener('click', function (e) {
          var target = storyTarget() || (hasComparison ? section : null);
          if (!target) return;
          e.preventDefault();

          var reduceMotion = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var offset = window.innerWidth < 750 ? 90 : 320;
          if (target === storySection) {
            offset = 12;
            var headers = document.querySelectorAll('.gobann-section--sticky, .header-section');
            for (var i = 0; i < headers.length; i++) {
              var style = window.getComputedStyle(headers[i]);
              var rect = headers[i].getBoundingClientRect();
              if ((style.position === 'sticky' || style.position === 'fixed') &&
                  rect.top <= offset && rect.bottom > 0) {
                offset = Math.max(offset, rect.bottom + 12);
              }
            }
          }
          var y = target.getBoundingClientRect().top + window.pageYOffset - offset;

          bar.classList.add('is-hiding');
          window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
          setTimeout(function () { bar.classList.remove('is-hiding'); }, reduceMotion ? 0 : 900);
        });
      } else {
        // No description target or comparison on this page.
        cmpBtn.parentNode.removeChild(cmpBtn);
      }
    }

    /* ---------- show once the real button has scrolled past the top ---------- */
    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('gob-satc-on', on);
      if (on) measure();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(realBtn);
    } else {
      window.addEventListener('scroll', function () {
        setVisible(realBtn.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    /* re-measure on rotate / resize — the bar reflows between the mobile
       three-row grid and the desktop single row */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(measure, 150);
    }, { passive: true });

    syncPrice();
    syncBtn();
    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
